module.exports = __webpack_public_path__ + "img/record.6b768d41.svg";